import { every, get, has, isArray, isNull, isNumber, isString, omit, startsWith } from 'lodash';
import light from '../../../../../styles/theme/light.json';
import { ValidationResult } from '../../models';
import { extractColorVarFromString } from '../../utils';

const VALID_COLOR_OPTIONS = Object.keys(omit(light, ['particle']));

export const isValidRatioBarData = (obj: any): ValidationResult => {
  let isValid = true;
  const errors: string[] = [];

  if (obj == undefined) {
    isValid = false;
    errors.push('Data is not defined');
    return { isValid, errors };
  }

  if (!isArray(obj)) {
    isValid = false;
    errors.push(`Data should be an array, but is of type ${typeof obj}`);
    return { isValid, errors };
  }

  isValid = every(obj, segmentObj => {
    let isLabelValid = true;
    let isValueValid = true;
    let isColorValid = true;

    if (get(segmentObj, 'label') && !isString(segmentObj.label)) {
      isLabelValid = false;
      errors.push(`Label should be a string, but is of type ${typeof segmentObj.label}`);
    }

    if (!has(segmentObj, 'value')) {
      isValueValid = false;
      errors.push("'value' property should be defined");
    }

    if (get(segmentObj, 'value') && !(isNumber(segmentObj.value) || isNull(segmentObj.value))) {
      isValueValid = false;
      errors.push(`Value should be a number or null, but is of type ${typeof segmentObj.value}`);
    }

    if (get(segmentObj, 'color')) {
      if (!isString(segmentObj.color)) {
        isColorValid = false;
        errors.push(`Color should be a string, but is of type ${typeof segmentObj.color}`);
      } else {
        const colorVar = extractColorVarFromString(segmentObj.color);
        if (colorVar) {
          // Check if color is a valid Magnetic color
          if (!VALID_COLOR_OPTIONS.includes(colorVar)) {
            isColorValid = false;
            errors.push(`Color '${colorVar}' is not supported`);
          }
        } else if (startsWith(segmentObj.color, '#') && !/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(segmentObj.color)) {
          // Check if color is a valid hex color
          isColorValid = false;
          errors.push(`Color '${segmentObj.color}' is not a valid hexcode`);
        } else {
          isColorValid = false;
          errors.push(`Color '${segmentObj.color}' is invalid`);
        }
      }
    }
    return isLabelValid && isValueValid && isColorValid;
  });

  if (errors.length > 0) {
    console.error('Error with ratio bar data: ', errors);
  }

  return { isValid, errors };
};
